import { yupResolver } from "@hookform/resolvers/yup"
import { Box, Button, Flex, Typography } from "@jewlr/storybook/core"
import { FloatInput } from "@jewlr/storybook/form"
import PropTypes from "prop-types"
import React, { useState } from "react"
import { useForm, Controller } from "react-hook-form"
import { connect } from "react-redux"
import { push } from "redux-first-history"
import isEmail from "validator/lib/isEmail"
import * as Yup from "yup"

import api from "apis"
import { history } from "app-store-v2"
import VibeModal from "jewlr/main/HalfModals/vibe_half_modal"

const schema = Yup.object().shape({
  email: Yup.string()
    .required("Please provide an email")
    .test("test-email", "Invalid email address", (value) =>
      isEmail(value || "")
    ),
  name: Yup.string()
    .required("Please provide a name")
    .min(2, "Min. 2 characters"),
})

const InternalVibeForm = ({
  mailList,
  promoCode,
  // , toggleReviewModal
}) => {
  const [showVibeModal, toggleVibeModal] = useState(false)
  const {
    control,
    formState: { errors, isSubmitting },
    handleSubmit,
    register,
    setError,
  } = useForm({
    defaultValues: {
      email: "",
      mail_list: mailList,
      name: "",
      promo_code: promoCode,
      subscribe: true,
    },
    mode: "onBlur",
    resolver: yupResolver(schema),
  })

  const onSubmit = async (values) => {
    try {
      let url = "/vibe"
      await api.post(url, values).then(() => {
        toggleVibeModal(true)
      })
    } catch (err) {
      console.log(err)
      setError("root.error", {
        message: err?.errors?.[0] || err?.message || err,
      })
    }
  }

  return (
    <Box mx="auto" width={{ tablet: "75%" }}>
      <form onSubmit={handleSubmit(onSubmit)}>
        {errors?.root?.error && (
          <Typography color="error" mb={1}>
            {errors.root.error.message}
          </Typography>
        )}
        <Flex justifyContent="space-between" mb={2}>
          <Controller
            control={control}
            name="name"
            render={({ field, fieldState: { error } }) => (
              <Box flexBasis="48%">
                <FloatInput
                  error={error}
                  label="Name"
                  mb="0"
                  p="0"
                  placeholder="Your Name"
                  {...field}
                />
              </Box>
            )}
            type="text"
          />
          <Controller
            control={control}
            name="email"
            render={({ field, fieldState: { error } }) => (
              <Box flexBasis="48%">
                <FloatInput
                  error={error}
                  label="Email"
                  mb="0"
                  p="0"
                  placeholder="Your Email"
                  {...field}
                />
              </Box>
            )}
            type="email"
          />
        </Flex>
        <Flex alignItems="flex-start" mb={2}>
          <input type="checkbox" {...register("subscribe")} />
          <Typography fontSize="14px" light mb={{ _: 3, tablet: 4 }} ml="5px">
            I would like to be a Jewlr VIP and receive exclusive offers.
          </Typography>
        </Flex>
        <Flex justifyContent="center">
          <Button
            disabled={isSubmitting}
            height="44px"
            loading={isSubmitting}
            mb={{ _: "45px", tablet: "56px" }}
            outline="black"
            sz="md"
            type="submit"
            width="160px"
          >
            Submit
          </Button>
        </Flex>
      </form>
      <VibeModal
        promoCode={promoCode}
        showVibeModal={showVibeModal}
        toggleVibeModal={toggleVibeModal}
      />
    </Box>
  )
}

InternalVibeForm.propTypes = {
  mailList: PropTypes.string.isRequired,
  promoCode: PropTypes.string.isRequired,
  toggleReviewModal: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleReviewModal: () => {
      dispatch(
        push(
          `${history.location.pathname}${history.location.search}#vibe-success`
        )
      )
    },
  }
}

const VibeForm = connect(null, mapDispatchToProps)(InternalVibeForm)
export default VibeForm
